import React from 'react';
import { Box, IconButton, Popover } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import type { ILottery } from 'types/ILottery';

import './LotteryInfoPopover.scss';

interface IProps {
  lottery: ILottery | null;
  anchorEl: HTMLElement | null;
  onClose: () => void;
}

export const LotteryInfoPopover: React.FC<IProps> = ({ lottery, anchorEl, onClose }) => {
  const rows: { label: string; value: string }[] = lottery
    ? [
        { label: 'Name', value: lottery.name || '-' },
        { label: 'Name (Abk.)', value: lottery.nameShort || '-' },
        { label: 'Adresse', value: lottery.address || '-' },
        { label: 'PLZ', value: lottery.zip || '-' },
        { label: 'Stadt', value: lottery.city || '-' },
        { label: 'Telefon', value: lottery.tel || '-' },
        { label: 'E-Mail', value: lottery.email || '-' },
        { label: 'Typ', value: lottery.lotteryType?.name || '-' },
      ]
    : [];

  return (
    <Popover
      open={Boolean(anchorEl && lottery)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      disableScrollLock
      slotProps={{ paper: { className: 'psf-lottery-info' } }}
    >
      <IconButton className="psf-lottery-info__close" onClick={onClose} size="small" aria-label="Schließen">
        <CloseIcon fontSize="small" />
      </IconButton>

      <Box component="table" className="psf-lottery-info__table">
        <tbody>
          {rows.map((row) => (
            <tr key={row.label}>
              <th>{row.label}</th>
              <td>{row.value}</td>
            </tr>
          ))}
        </tbody>
      </Box>
    </Popover>
  );
};
